module.exports = __webpack_public_path__ + "static/img/legend_xa_spanish.0e1d458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_spanish.png
// module id = 4mpf
// module chunks = 79